import { useCallback, useMemo } from 'react'
import { useAppSetting } from '../useAppSettings/index'
import { Duration, jsonTryParse } from '@ztechapps/common.utils'
import type { WorkdayConfig } from '@ztechapps/common.contract'

const DEFAULT_WORKDAY_CONFIG: WorkdayConfig = { hoursPerDay: 8, daysPerWeek: 5 }

export type UseFormatWorkdayTimeResult = {
  formatTime: (minutes: number) => string
  loading: boolean
  workdayConfig: WorkdayConfig
}

export const useFormatWorkdayTime = (): UseFormatWorkdayTimeResult => {
  const { setting, loading } = useAppSetting({ appSettingKey: 'WORKDAY_CONFIGURATION' })

  const workdayConfig = useMemo<WorkdayConfig>(() => {
    const raw = setting?.value
    if (!raw) return DEFAULT_WORKDAY_CONFIG

    const parsed = typeof raw === 'string' ? jsonTryParse(raw) : raw
    if (!parsed || typeof parsed !== 'object') return DEFAULT_WORKDAY_CONFIG

    return {
      hoursPerDay: parsed.hoursPerDay ?? DEFAULT_WORKDAY_CONFIG.hoursPerDay,
      daysPerWeek: parsed.daysPerWeek ?? DEFAULT_WORKDAY_CONFIG.daysPerWeek,
    }
  }, [setting?.value])

  const formatTime = useCallback((minutes: number) => Duration.format(minutes, { workdayConfig }), [workdayConfig])

  return { formatTime, loading, workdayConfig }
}
